<template>
  <div class="page">
    <!-- 顶部通栏：标题 + 查询条件 -->
    <div class="top-bar">
      <div class="top-left">
        <h1 class="page-title">教學視頻</h1>
      </div>
      <div class="top-search">
        <div class="search-row">
          <div class="search-item">
            <div class="label">課題編號</div>
            <el-input v-model="listQuery.numberLike" size="small" placeholder="請輸入" clearable></el-input>
          </div>
          <div class="search-item">
            <div class="label">課程版本</div>
            <el-select v-model="listQuery.lang" size="small" placeholder="請選擇" clearable>
              <el-option v-for="item in languages" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <div class="label">年級</div>
            <el-select v-model="listQuery.gradeId" size="small" placeholder="請選擇" clearable>
              <el-option v-for="(item, index) in grades" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
          <el-button type="warning" size="small" icon="el-icon-search" @click="onSearch">搜尋</el-button>
        </div>
      </div>
    </div>

    <div class="double-layout">
      <!-- 左侧：窄菜单 240px -->
      <div class="layout layout-left">
        <div class="topic-list">
          <div
              v-for="item in topicsTableData"
              :key="item.id"
              class="topic-item"
              :class="{ active: activeId === item.id }"
              @click="selectTopic(item.id)"
          >
            <div class="topic-num">{{ item.number }}</div>
            <div class="topic-name">{{ item.name }}</div>
            <el-tag size="mini" :type="item.lang === 0 ? 'warning' : 'success'">
              {{ item.lang | language }}
            </el-tag>
          </div>

          <div v-if="topicsTableData.length === 0" class="empty-topic">暫無數據</div>
        </div>

        <!-- 极简分页：只显示 总数 + 上一页 下一页 -->
        <div class="pagination-container" v-show="topicsTotal > 0">
          <div class="simple-pagination">
            <span>共 {{ topicsTotal }} 條</span>
            <div class="btns">
              <el-button
                  size="mini"
                  icon="el-icon-arrow-left"
                  :disabled="listQuery._page === 1"
                  @click="listQuery._page--; getTopics()"
              >上一頁</el-button>
              <el-button
                  size="mini"
                  icon="el-icon-arrow-right"
                  :disabled="listQuery._page * listQuery._limit >= topicsTotal"
                  @click="listQuery._page++; getTopics()"
              >下一頁</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：九宫格 -->
      <div class="layout layout-right">
        <div class="grid-container">
          <div v-if="topicsPractises.length === 0" class="empty">
            <i class="el-icon-video-off"></i>
            <p>請選擇左側課題</p>
          </div>

          <div v-for="item in topicsPractises" :key="item.id" class="grid-card" @click="openVideo(item)">
            <div class="cover">
<!--              <img v-if="item.guideVideoCover" :src="item.guideVideoCover" alt="封面">-->
              <div class="no-cover"><i class="el-icon-video-play"></i></div>
              <el-button
                  v-if="item.guideVideoUrl"
                  type="primary"
                  size="mini"
                  icon="el-icon-video-play"
                  class="play-btn">播放</el-button>
            </div>
            <div class="title">{{ item.number }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- iPad 风格视频弹窗 -->
    <el-dialog
        :title="currentVideoTitle"
        :visible.sync="videoDialogVisible"
        width="1000px"
        center
        append-to-body
        @close="handleVideoDialogClose"
        class="video-dialog-ipad"
    >
      <div class="video-body">
        <div v-if="currentVideoUrl" class="video-iframe-box">
          <iframe
              :src="currentVideoUrl"
              width="100%"
              height="540"
              frameborder="0"
              allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
              allowfullscreen
          ></iframe>
        </div>
        <div v-else class="no-video-style">
          <i class="el-icon-video-off"></i>
          <p>暫無教學視頻</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTopics, getTopicsDetail } from "@/api/topics";
import { getGrades } from "@/api/grade";

export default {
  filters: {
    language(value) { return value === 0 ? "中文" : "英文"; }
  },
  data() {
    return {
      languages: [{ value: 0, label: "中文" }, { value: 1, label: "英文" }],
      listQuery: { numberLike: null, gradeId: null, lang: 0, _page: 1, _limit: 300 },
      topicsTableData: [],
      topicsTotal: 0,
      grades: [],
      topicsPractises: [],
      activeId: null,
      videoDialogVisible: false,
      currentVideoUrl: "",
      currentVideoTitle: ""
    };
  },
  created() {
    this.getGrades();
    this.getTopics();
  },
  methods: {
    getTopics() {
      const params = { ...this.listQuery, _page: this.listQuery._page - 1 };
      const loading = this.$loading({ lock: true, text: "加載中..." });
      getTopics(params).then(res => {
        this.topicsTableData = res.data || [];
        this.topicsTotal = Number(res.headers["x-total-count"]) || 0;
        if (this.topicsTableData.length) this.selectTopic(this.topicsTableData[0].id);
        else { this.topicsPractises = []; this.activeId = null; }
      }).finally(() => loading.close());
    },
    selectTopic(id) {
      this.activeId = id;
      getTopicsDetail(id).then(res => {
        this.topicsPractises = res.data?.practises || [];
      });
    },
    openVideo(row) {
      this.currentVideoUrl = row.guideVideoUrl;
      this.currentVideoTitle = row.number;
      this.videoDialogVisible = true;
    },
    handleVideoDialogClose() { this.currentVideoUrl = ""; },
    onSearch() { this.listQuery._page = 1; this.getTopics(); },
    getGrades() { getGrades().then(res => this.grades = res.data || []); }
  }
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: 100vh;
}

/* 顶部通栏：标题 + 查询 */
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;
}
.top-left .page-title {
  font-size: 22px;
  font-weight: 600;
  color: #B62D2E;
  margin: 0;
}
.top-search {
  display: flex;
  align-items: end;
}
.search-row {
  display: flex;
  align-items: end;
  gap: 12px;
}
.search-item {
  .label {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
  }
}

/* 左右布局：左侧超窄 */
.double-layout {
  display: flex;
  gap: 16px;
  .layout-left  { flex: 0 0 240px; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
  .layout-right { flex: 1; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); padding: 20px; }
}

/* 左侧菜单 */
.topic-list {
  padding: 12px 10px;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
}
.topic-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 4px;
  transition: all 0.2s;

  &:hover { background: #f5f7fa; }
  &.active { background: #e8f3ff; font-weight: 500; }

  .topic-num { min-width: 60px; color: #166ea5; font-size: 13px; font-weight: 500; }
  .topic-name { flex: 1; font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
}
.empty-topic { text-align: center; padding: 30px 0; color: #999; }
.pagination-container { padding: 8px 10px; text-align: center; }

/* 右侧九宫格 */
.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.grid-card {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e5e6eb;
  transition: all 0.2s;
  &:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
}
.cover {
  position: relative;
  width: 100%;
  height: 120px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  img { width: 100%; height: 100%; object-fit: cover; }
}
.no-cover { font-size: 30px; color: #ccc; }
.play-btn {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
}
.title { padding: 8px 12px; text-align: center; font-weight: 500; color: #333; }
.empty { grid-column: 1/-1; text-align: center; padding: 100px 0; color: #999; }

/* 极简分页 */
.simple-pagination {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 0;
  font-size: 12px;
  color: #666;
  .btns { display: flex; gap: 4px; }
}

/* ====================== iPad 风格视频弹窗 ====================== */
::v-deep .video-dialog-ipad {
  .el-dialog {
    border-radius: 28px !important;
    overflow: hidden !important;
    box-shadow: 0 25px 90px rgba(0, 0, 0, 0.4) !important;
  }
  .el-dialog__header {
    background: #1c1c1e;
    padding: 20px 24px;
    margin: 0;
    border-bottom: 1px solid #3a3a3c;
  }
  .el-dialog__title {
    color: #ffffff;
    font-size: 17px;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #ffffff !important;
    font-size: 22px;
  }
  .el-dialog__body {
    padding: 0 !important;
    background: #000000;
    border-radius: 28px 28px 28px 28px !important;
  }
}

.video-body {
  width: 100%;
  height: 540px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.video-iframe-box {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
    display: block;
    border: none;
  }
}

.no-video-style {
  text-align: center;
  i {
    font-size: 70px;
    color: #555;
    margin-bottom: 16px;
  }
  p {
    font-size: 16px;
    color: #999;
    margin: 0;
  }
}
</style>